import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'i18n-js';
import { Spin } from 'grab-ui';
import PageContentPanel from 'components/v2/page-content-panel';
import { ShopContext } from 'views/v2/shopify-home/contexts/shop-context';
import ShopBasicSettingsForm, { MODE } from './shop-basic-settings-form';
import styles from './shop-basic-settings-section.less';

const ShopBasicSettingsSection = ({ isCreateMode }) => {
  const { shop } = React.useContext(ShopContext);
  const [loading, setLoading] = React.useState(false);

  const makeInitialMode = () => {
    if (isCreateMode) return MODE.CREATE;
    if (!shop.productCategoryID) return MODE.EDIT;
    return MODE.READ;
  };

  return (
    <Spin spinning={loading}>
      <PageContentPanel
        className={styles.ShopBasicSettingsSection}
        header={I18n.t('shopify.settings.basicSettingsSection.header')}
        message={I18n.t('shopify.settings.basicSettingsSection.message')}
      >
        <div className={styles.FormContainer}>
          <ShopBasicSettingsForm
            loading={loading}
            setLoading={setLoading}
            initialMode={makeInitialMode()}
          />
        </div>
      </PageContentPanel>
    </Spin>
  );
};

ShopBasicSettingsSection.propTypes = {
  isCreateMode: PropTypes.bool.isRequired,
};

export default ShopBasicSettingsSection;
